import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import About from "./components/AboutSection/AboutSection";
import Privacy from "./components/PrivacySection/PrivacySection"; // ✅ нов импорт
import Hero from "./components/Hero/Hero";
import ModuleSection from "./components/ModuleSection/ModuleSection";
import PartnerSection from "./components/PartnersSection/PartnerSection";
import ContactSection from "./components/ContactSection/ContactSection";
import Footer from "./components/Footer/Footer";

function Home() {
  return (
    <>
      <Hero />
      <ModuleSection />
      <PartnerSection />
      <ContactSection />
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} /> 
      </Routes>
    </BrowserRouter>
  );
}

export default App;
